module.exports = __webpack_public_path__ + "img/20220116_161004.b2ec0c73.jpg";